import React from 'react';
import { Alert, Button } from 'react-bootstrap';

/**
 * Reusable header component for DataGrid tables
 * Handles conditional rendering of header content
 * 
 * @param {ReactNode} headerContent - Optional custom content to render (takes priority)
 * @param {boolean} showLoadingAlert - Whether to show the loading alert
 * @param {string} loadingMessage - Message to display in loading alert
 * @param {boolean} showAddButton - Whether to show the add row button
 * @param {string} addButtonText - Text to display on add button
 * @param {Function} onAddRow - Callback when add button is clicked
 * @param {boolean} addButtonDisabled - Whether add button should be disabled
 * @param {string} addButtonIcon - Material icon name for add button
 */
export function DataGridHeader(_ref) {
  let {
    headerContent = null,
    showLoadingAlert = false,
    loadingMessage = 'Loading...',
    showAddButton = false,
    addButtonText = 'Add Row',
    onAddRow,
    addButtonDisabled = false,
    addButtonIcon = 'add'
  } = _ref;
  // If custom headerContent is provided, render it
  if (headerContent) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, headerContent);
  }

  // If neither loading alert nor add button should be shown, render nothing
  if (!showLoadingAlert && !showAddButton) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  // Render built-in header with loading alert and/or add button
  return /*#__PURE__*/React.createElement(React.Fragment, null, showLoadingAlert && /*#__PURE__*/React.createElement(Alert, {
    className: "mt-2",
    variant: "info"
  }, loadingMessage), showAddButton && /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    onClick: onAddRow,
    disabled: addButtonDisabled
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, addButtonIcon), " ", addButtonText)));
}